const filterArrayWithQuery = (data: any, query: any) => {
    return data.filter(
        (option: any) =>
            option.label.toLowerCase().indexOf(query.toLowerCase()) > -1
    );
};
export { filterArrayWithQuery };
